import { createI18n } from 'vue-i18n'
import enUS from './en-US.json'
import zhCN from './zh-CN.json'
import jaJP from './ja-JP.json'
import deDE from './de-DE.json'

const messages = {
  'en-US': enUS,
  'zh-CN': zhCN,
  'ja-JP': jaJP,
  'de-DE': deDE,
}

const SUPPORTED_LOCALES = ['en-US', 'zh-CN', 'ja-JP', 'de-DE'] as const
const DEFAULT_LOCALE = 'en-US'

/**
 * 语言判断：纯跟随浏览器语言（无手动切换入口，不读 localStorage，避免残留值卡住）。
 * 浏览器语言按主语言标签匹配（如 zh-TW / zh-HK → zh-CN，ja → ja-JP），无匹配回退英文。
 */
function detectLocale(): string {
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language]
  for (const lang of langs) {
    if (!lang) continue
    const lower = lang.toLowerCase()
    const exact = SUPPORTED_LOCALES.find((l) => l.toLowerCase() === lower)
    if (exact) return exact
    const prefix = lower.split('-')[0]
    const byPrefix = SUPPORTED_LOCALES.find((l) => l.split('-')[0].toLowerCase() === prefix)
    if (byPrefix) return byPrefix
  }
  return DEFAULT_LOCALE
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages,
})

export default i18n
